$(document).ready(function () {
	$("#ma-mobilemenu .had_child, #ma-mobilemenu .had_child .had_grandchild").each(function() {
        $(this).append('<span class="ttclose ttnavigation"><a></a></span>');
      });
	$("#ma-mobilemenu li.active").each(function() {
		$(this).children().next("ul").css('display', 'block');
	});
	$("#ma-mobilemenu li ul").hide();

	// origin menu
	$('.originalmenu span.ttnavigation').click(function(){
		if ($(this).hasClass('ttopen')) {varche = true} else {varche = false};
		if (varche == false) {
			$(this).addClass("ttopen");
			$(this).removeClass("ttclose");
			$(this).parent().children('ul').slideDown();
			varche = true;
		} else {
			$(this).removeClass("ttopen");
			$(this).addClass("ttclose");
			$(this).parent().children('ul').slideUp();
			varche = false;
		}
	});

	//mobile
	$('.btn-navbar').click(function() {
		var chk = 0;
		if ( $('#navbar-inner').hasClass('navbar-inactive') && ( chk==0 ) ) {
			$('#navbar-inner').removeClass('navbar-inactive');
			$('#navbar-inner').addClass('navbar-active');
			$('body').addClass('nav-open');
			$('#ma-mobilemenu').fadeIn();
			setTimeout(function () {$('#ma-mobilemenu').addClass('animateIn');},300);
			chk = 1;
		}
		if ($('#navbar-inner').hasClass('navbar-active') && ( chk==0 ) ) {
			$('#navbar-inner').removeClass('navbar-active');
			$('#navbar-inner').addClass('navbar-inactive');
			$('body').removeClass('nav-open');
			$('#ma-mobilemenu').removeClass('animateIn');
			$('#ma-mobilemenu').fadeOut();
			chk = 1;
		}
	});
});